import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

type SourcesRequiredDialogProps = {
  open: boolean
  onClose: () => void
}

export function SourcesRequiredDialog({ open, onClose }: SourcesRequiredDialogProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("pages.ai_explorer.sources_required_title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("pages.ai_explorer.sources_required_description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>{t("pages.common.ok")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
